import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconClock, IconLocationPin, IconSalary } from '@xingternal/icons';
import { SingleSizeIllustrationExtVerified } from '@xingternal/illustrations';

import { useHeaderContext } from '../../context';
import { FormattedSalary } from '../formatted-salary';
import { InfoIcon } from './info-icon';

import * as S from './info-icons.styles';

export const InfoIcons: React.FC = () => {
  const { isVerifiedByXing, city, employmentType, salary, isMatchingSalary } = useHeaderContext();
  // Show salary as info icon when salary is not a matching fact
  const showSalaryInfoIcon = !isMatchingSalary && salary;

  return (
    <S.InfoIcons>
      {isVerifiedByXing ? (
        <InfoIcon Icon={SingleSizeIllustrationExtVerified} data-testid="verified-by-xing-info-icon">
          <FormattedMessage id="JOBS_JOB_DETAILS_XING_VERIFIED" />
        </InfoIcon>
      ) : null}
      {city ? (
        <InfoIcon Icon={IconLocationPin} data-testid="location-info-icon">
          {city}
        </InfoIcon>
      ) : null}
      {employmentType ? (
        <InfoIcon Icon={IconClock} data-testid="employment-type-info-icon">
          {employmentType}
        </InfoIcon>
      ) : null}
      {showSalaryInfoIcon ? (
        <InfoIcon Icon={IconSalary} data-testid="salary-info-icon">
          <FormattedSalary salary={salary} />
        </InfoIcon>
      ) : null}
    </S.InfoIcons>
  );
};
